/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignInformationDTO
 */
export interface SignInformationDTO {
    /**
     * 
     * @type {string}
     * @memberof SignInformationDTO
     */
    careProviderName?: string;
    /**
     * 
     * @type {string}
     * @memberof SignInformationDTO
     */
    careProviderId?: string;
    /**
     * 
     * @type {string}
     * @memberof SignInformationDTO
     */
    careProviderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SignInformationDTO
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {string}
     * @memberof SignInformationDTO
     */
    contractFileName?: string;
    /**
     * 
     * @type {string}
     * @memberof SignInformationDTO
     */
    logoFileName?: string;
    /**
     * 
     * @type {string}
     * @memberof SignInformationDTO
     */
    signName?: string;
    /**
     * 
     * @type {string}
     * @memberof SignInformationDTO
     */
    signId?: string;
}

export function SignInformationDTOFromJSON(json: any): SignInformationDTO {
    return SignInformationDTOFromJSONTyped(json, false);
}

export function SignInformationDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignInformationDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'careProviderName': !exists(json, 'careProviderName') ? undefined : json['careProviderName'],
        'careProviderId': !exists(json, 'careProviderId') ? undefined : json['careProviderId'],
        'careProviderNumber': !exists(json, 'careProviderNumber') ? undefined : json['careProviderNumber'],
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'contractFileName': !exists(json, 'contractFileName') ? undefined : json['contractFileName'],
        'logoFileName': !exists(json, 'logoFileName') ? undefined : json['logoFileName'],
        'signName': !exists(json, 'signName') ? undefined : json['signName'],
        'signId': !exists(json, 'signId') ? undefined : json['signId'],
    };
}

export function SignInformationDTOToJSON(value?: SignInformationDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'careProviderName': value.careProviderName,
        'careProviderId': value.careProviderId,
        'careProviderNumber': value.careProviderNumber,
        'carePrincipalId': value.carePrincipalId,
        'contractFileName': value.contractFileName,
        'logoFileName': value.logoFileName,
        'signName': value.signName,
        'signId': value.signId,
    };
}

